<template>
  <div class="cvs-alert-main">
    <transition name="opacity">
      <div class="cover" v-if="alertData.show" @click="closeDialog"></div>
    </transition>
    <transition name="opacity">
      <!-- 选择身份 -->
      <div class="box identity" v-if="data.show && data.type === 'identity'">
        <i class="close iconfont iconx" @click.stop="close"></i>
        <div class="identity-title">你的身份是</div>
        <div class="identity-option">
          <div class="identity-item" @click.stop.prevent="selectIdentity(1)" @mousedown.prevent>
            <img
                :src="identity === 1 ? 'https://files.wondercv.com/pcvue/w2.png' : 'https://files.wondercv.com/pcvue/w1.png'"
                alt="">
            <p>学生</p>
          </div>
          <div class="identity-item" @click.stop.prevent="selectIdentity(2)" @mousedown.prevent>
            <img
                :src="identity === 2 ? 'https://files.wondercv.com/pcvue/m2.png' : 'https://files.wondercv.com/pcvue/m1.png'"
                alt="">
            <p>职场人</p>
          </div>
        </div>
      </div>
      <!-- 线上简历 -->
      <div class="box on-line" v-if="data.show && data.type === 'onLine'">
        <i class="close iconfont iconx" @click.stop="close" v-if="step[0] === 'onLine'"></i>
        <div class="on-title">选择一份简历开启推荐</div>
        <div class="on-msg">简历建议及时更新，获得优质 HR 推荐</div>
        <div class="on-content">
          <template v-for="(item, index) in cvs">
            <div
                :class="['on-menu', cv.token === item.token ? 'active' : '']"
                :key="item.token"
                v-if="!item.is_mentor && item.lang === 'cn' && item.can_editable"
                @click="selectCv(item, index)">
              <div class="on-menu-select"><i class="iconfont iconcheck"></i></div>
              <div class="on-menu-text text-overflow">{{ item['name'] || item['cv_name'] || ''}}</div>
              <div class="on-menu-tag">
                <div class="blue">{{item.lang | langFilter}}</div>
                <div class="red">{{ item.score === null ? 40 : item.score }}分</div>
              </div>
            </div>
          </template>
        </div>
        <div class="btn">
          <button class="prev-btn" @click="onlinePrev" v-if="getShowPrev('onLine')">上一步</button>
          <button :class="cv.token ? 'active' : 'disabled'" @click="selectCvNuxt()">下一步</button>
        </div>
      </div>
      <!-- 设置信息 -->
      <div class="box base-info" v-if="alertData.show && data.type === 'baseInfo'">
        <i class="close iconfont iconx" @click.stop="close"
           v-if="(step[0] === 'baseInfo') || (updatedType === 'updated' && step[1] === 'baseInfo')"></i>
        <div class="base-title">请补充基本信息</div>
        <div class="base-msg">个人信息</div>
        <el-form class="base-form">
          <div class="base-option">
            <div class="base-item">
              <el-form-item>
                <div class="base-name">姓名</div>
                <el-input v-model="name" placeholder="请填写姓名" @input="getIsBaseInfoNuxt"/>
              </el-form-item>
            </div>
            <div class="base-item">
              <el-form-item>
                <div class="base-name">性别</div>
                <el-select
                    clearable
                    v-model="gender"
                    placeholder="请选择性别"
                    @input="getIsBaseInfoNuxt">
                  <el-option
                      v-for="option in ['男', '女']"
                      :key="option"
                      :label="option"
                      :value="option"/>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <el-form-item>
            <div class="base-name">联系方式</div>
            <el-input placeholder="请填写联系方式" v-model="contact" class="phone" @input="getIsBaseInfoNuxt"
                      :disabled="isPhoneDisabled">
              <template slot="prepend">+86</template>
              <template slot="append" v-if="isPhoneDisabled">
                <span @click="isPhoneDisabled = false; getIsBaseInfoNuxt()">修改</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :style="{opacity: isPhoneDisabled ? 0 : 1}">
            <div class="base-name">验证码</div>
            <el-input placeholder="请输入验证码" v-model="code" class="code" @input="getIsBaseInfoNuxt">
              <template slot="append">
                <span @click="sendCode">{{codeText}}</span>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="btn">
          <button class="prev-btn" @click="baseInfoPrev"
                  v-if="(step[0] !== 'baseInfo') && !(updatedType === 'updated' && step[1] === 'baseInfo')">上一步
          </button>
          <button :class="[isBaseInfoNext ? 'active' : 'disabled']" @click="baseInfoNext">下一步</button>
        </div>
      </div>
      <!-- edu -->
      <div class="box base-info" v-if="alertData.show && data.type === 'edu'">
        <i class="close iconfont iconx" @click.stop="close"
           v-if="(step[0] === 'edu') || (updatedType === 'updated' && step[1] === 'edu')"></i>
        <div class="base-title">请补充基本信息</div>
        <div class="base-msg">教育经历</div>
        <el-form class="base-form">
          <el-form-item>
            <div class="base-name">学校</div>
            <el-input placeholder="请填写学校名称" v-model="edu.university" @change="getIsEduNext">
            </el-input>
          </el-form-item>
          <div class="base-option">
            <div class="base-item">
              <el-form-item>
                <div class="base-name">专业</div>
                <el-input v-model="edu.major" placeholder="请填写专业名称" @change="getIsEduNext"/>
              </el-form-item>
            </div>
            <div class="base-item">
              <el-form-item>
                <div class="base-name">学历</div>
                <el-select
                    clearable
                    placeholder="请选择"
                    v-model="edu.degree"
                    value-key="id"
                    @change="getIsEduNext">
                  <el-option
                      v-for="(option, index) in degreeOptions"
                      :key="index"
                      :label="option.cn"
                      :value="option"/>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="base-option">
            <div class="base-item">
              <el-form-item>
                <div class="base-name">教育时间</div>
                <el-date-picker
                    v-model="edu.start_at"
                    align="right"
                    type="month"
                    placeholder="开始时间"
                    value-format="yyyy-MM"
                    :default-value="new Date().getFullYear() - 4 + '-09'"
                    @change="getIsEduNext('start_at')"/>
              </el-form-item>
            </div>
            <div class="base-item">
              <el-form-item>
                <div class="base-name"></div>
                <el-date-picker
                    v-model="edu.end_at"
                    align="right"
                    type="month"
                    placeholder="结束时间"
                    value-format="yyyy-MM"
                    :default-value="defaultEduTimePicker"
                    @change="getIsEduNext('end_at')"/>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="btn">
          <button class="prev-btn" @click="eduPrev"
                  v-if="(step[0] !== 'edu') && !(updatedType === 'updated' && step[1] === 'edu')">上一步
          </button>
          <button :class="[isEduNext ? 'active' : 'disabled']" @click="eduNext">下一步</button>
        </div>
      </div>
      <!-- work -->
      <div class="box base-info" v-if="alertData.show && data.type === 'work'">
        <i class="close iconfont iconx" @click.stop="close"
           v-if="(step[0] === 'work') || (updatedType === 'updated' && step[1] === 'work')"></i>
        <div class="base-title">请补充基本信息</div>
        <div class="base-msg">工作经历</div>
        <el-form class="base-form">
          <el-form-item>
            <div class="base-name">公司名称</div>
            <el-input placeholder="请填写公司名称" v-model="work.company" @input="getIsWorkNext">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="base-name">职位</div>
            <el-input placeholder="请填写职位" v-model="work.title" @input="getIsWorkNext">
            </el-input>
          </el-form-item>
          <div class="base-name">在职时间</div>
          <div class="base-option">
            <div class="base-item">
              <el-form-item>
                <el-date-picker
                    v-model="work.start_at"
                    align="right"
                    type="month"
                    placeholder="入职时间"
                    value-format="yyyy-MM"
                    @change="getIsWorkNext"/>
              </el-form-item>
            </div>
            <div class="base-item present">
              <el-form-item>
                <div class="edit-item-now" v-if="work.present">{{work.present}}</div>
                <el-date-picker
                    v-model="work.end_at"
                    align="right"
                    type="month"
                    placeholder="离职时间"
                    value-format="yyyy-MM"
                    :picker-options="pickerOptions"
                    :editable="false"
                    :validate-event="false"
                    @change="work.present = '' ;getIsWorkNext(); "/>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="btn">
          <button class="prev-btn" @click.stop="workPrev()"
                  v-if="(step[0] !== 'work') && !(updatedType === 'updated' && step[1] === 'work')">上一步
          </button>
          <button :class="[isWorkNext ? 'active' : 'disabled']" @click="workNext()">下一步</button>
        </div>
      </div>
      <!-- end -->
      <div class="box end" v-if="alertData.show && data.type === 'end'">
        <img class="end-img" src="https://files.wondercv.com/pcvue/end.png" alt="">
        <div class="end-title">已开启智能推荐</div>
        <div class="end-msg">HR 可能对你发出职位邀请，下载超级简历 App 立刻和 HR 直聊！</div>
        <button class="end-btn" @click="close('downloadApp'); $message.success(updatedType === 'updated' ? '简历已更新' : '简历已推荐')">
          点击下载 App
        </button>
      </div>
      <!-- 求职意向 -->
      <intention
        :isClose="step[0] === 'intention'"
        :showPrev="getShowPrev('intention')"
        v-if="alertData.show && data.type === 'intention'"
        :show="alertData.show && data.type === 'intention'"
        @close="close"
        @prev="intentionPrev"
        @next="intentionNext"
      />
      <!-- 积分引流下载app -->
      <div class="box download-app" v-if="alertData.show && data.type === 'drainage'">
        <div class="title">兑换免费会员</div>
        <div class="score">当前账户内有<span>{{alertData.score}}个积分，</span>扫码兑换免费会员</div>
        <img src="https://files.wondercv.com/PC/cvs/downloadapp.png" alt="">
        <div class="bottom">扫码下载APP，立即兑换</div>
      </div>
      <!-- cvs广告 -->
      <div class="box groups-cvs" v-if="alertData.show && data.type === 'cvsguanggao'" @click="clickBannerImage(alertData.image)">
        <div
          v-if="alertData.image &&
            (alertData.image.job_infos && alertData.image.job_infos.length ||
            alertData.image.comp_recruit_infos && alertData.image.comp_recruit_infos.length) && !alertData.image.deliver_channel
          "
          class="jobs-dialog-container"
          :style="{'background-image': `url(${alertData.image.image})`}"
        >
            <template v-if="alertData.image.job_infos.length">
              <swiper ref="mySwiper1" class="jobs-swiper" :options="swiperOptions" @slideChange="slideChange">
                <swiper-slide v-for="(item, index) in alertData.image.job_infos" :key="index" class="swiper-slide">
                  <div @click.stop>
                    <job-item-card :data="item" width="440px"></job-item-card>
                  </div>
                </swiper-slide>
              </swiper>
            </template>
            <template v-else-if="alertData.image.comp_recruit_infos.length">
              <swiper ref="mySwiper2" class="jobs-swiper" :options="swiperOptions" @slideChange="slideChange">
                <swiper-slide v-for="(item, index) in alertData.image.comp_recruit_infos" :key="index" class="swiper-slide">
                  <div class="job-card-content" @click.stop="goToDetail(item.comp_recruit_info && item.comp_recruit_info.token)">
                    <div class="content_img">
                      <img :src="item.company_logo || item.company_logo_hr || 'https://files.wondercv.com/icon/Artboard.png'" alt="" />
                    </div>
                    <div class="category-info">
                      <div class="content_infos">
                        <p class="infos_comp">{{item.comp_recruit_info && item.comp_recruit_info.comp_name}}</p>
                        <p class="infos_cate">{{item.category}} | <span>{{ item.city_names | cityFilter }}</span></p>
                      </div>
                      <div class="time">
                        <i class="iconfont iconshijian" style="color: #FF6644;"></i>
                        <p class="infos_time">{{recruitmentTime(item.comp_recruit_info)}}</p>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </template>
          <img class="left-arrow" src="https://logo.wondercv.com/banners/3sfjjHwEyZxlod3.png" alt="" @click.stop="handleClickArrow('left')" />
          <img class="right-arrow" src="https://logo.wondercv.com/banners/5N7a9FVBw29n2XY.png" alt="" @click.stop="handleClickArrow('right')" />
          <div
            v-if="alertData.image && alertData.image.title"
            class="bottom-btn"
            @click.stop="cvslink(alertData.image.link, 'button')"
          >{{alertData.image.title}}</div>
        </div>
        <img v-else :src="alertData.image.image" alt="" >
      </div>
      <!-- 机构号弹窗 -->
      <div class="box groups" v-if="alertData.show && data.type === 'groups'">
        <div class="groups-left">
          <h5 class="groups-left-title">校友专属福利</h5>
          <div class="groups-left-item">
            <h6>校友专属</h6>
            <p><span>{{ alertData.schoolName }}</span>专属会员</p>
          </div>
          <div class="groups-left-item">
            <h6>校友专属</h6>
            <p>2022 大厂校招简历模板</p>
          </div>
          <div class="groups-left-item">
            <h6>校友专属</h6>
            <p>应届生高薪技术简历模板</p>
          </div>
          <img class="groups-left-bg" src="https://files.wondercv.com/PC/jigouhao.png" alt="">
        </div>
        <div class="groups-right">
          <img class="groups-right-logo" :src="alertData.schoolLogo" alt="">
          <h5 class="groups-right-title">校友专属会员免费领</h5>
          <qrcode-vue class="groups-right-qrcode" :value="`${host}/groups/${alertData.groupToken}/invite?account=${_c_t}`" :size="180"/>
          <p class="groups-right-desc">扫码立即领取校友专属会员</p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { dealSignatrue, get_tUser, recruitmentTime, routerTo } from '@/assets/js/util'
  import api from '@/api'
  import intention from './intention'
  import degree from '@/assets/json/degree'
  import conditions from '@/assets/json/conditions'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import qrcodeVue from 'qrcode-vue'
  import JobItemCard from '../../jobs/components/itemCard.vue'

  const moment = require('moment')

	export default {
		name: 'CvsAlert',
		components: {
			intention,
      qrcodeVue,
      swiper,
      swiperSlide,
      JobItemCard
		},
		props: [ 'alertData', 'updatedType' ],
		data () {
			return {
				_c_t: '',
				data: {}, // 弹窗数据
				identity: '', // 身份
				cv: {}, // 选中的简历
				intentionShow: true, // 求职意向显示
				step: [], // 步骤流程
				cvCheck: {}, // 简历检查数据

        defaultEduTimePicker: '', // 教育结束时间picker默认值

				name: '', // 姓名
				gender: '', // 性别
				contact: '', // 联系方式
				code: '', // 验证码
				codeText: '获取验证码',
				isPhoneDisabled: false, // 是否有phone
				isBaseInfoNext: false, // 是否可下一步

				// edu
				isEduNext: false,
				edu: {
					university: '', // 学校
					major: '', // 专业
					degree: '', // 学历
					start_at: '',
					end_at: ''
				},

				// work
				isWorkNext: false,
				work: {
					company: '', // 公司
					title: '', // 职位
					start_at: '', // 开始时间
					end_at: '' // 结束时间
				},

				pickerOptions: {
					shortcuts: [
						{
							text: '至今',
							onClick: (picker) => {
								picker.$emit('pick', '')

								setTimeout(() => {
									this.work = {
										...this.work,
										present: '至今',
										end_at: ''
									}
									this.getIsWorkNext()
								}, 50)
							}
						}
					]
				},
        setReady: false,

        host: null,

        swiperOptions: {
          height: 153,
          slidesPerView: 'auto',
          centeredSlides: true,
          loop: true,
          spaceBetween: 20,
          initialSlide: 0
        },
        swiperIndex: 0
			}
		},
    filters: {
      cityFilter(val) {
        if (val && val.length) {
          let cityStr = ''
          val.forEach((item, index) => {
            if (index < 2) cityStr += `${ item }、`
          })
          return val.length > 2 ? cityStr.slice(0, -1) + '等' : cityStr.slice(0, -1)
        } else {
          return '全国'
        }
      }
    },
		computed: {
			...mapState('cv', [ 'cvs' ]),
			...mapState('jobs', [ 'intention', 'cities', 'userIntentions' ]),
			...mapState('editor', [ 'cvDetail', 'edus', 'works' ]),
      degreeOptions () {
				return degree
      },
      cnList() {
				return this.cvs.filter(item => !item.mentor_id && item.lang === 'cn' && item.can_editable)
      },
      swiper() {
        return this.alertData?.image?.job_infos?.length ? this.$refs.mySwiper1.swiper : this.$refs.mySwiper2.swiper;
      }
		},
		watch: {
			// 检测 alertDat
			alertData: {
				deep: true,
				immediate: true,
				handler: async function (alertData) {
					this.data = JSON.parse(JSON.stringify(alertData))
					if (!alertData.show) {
						return false
					}
					// 更新
					if (alertData.showType === 'perfect') {
						this.cv = alertData.cv // 判断信息完善直接更新
						this.data.type = ''
						this.selectCvNuxt()
					}
					this.step = [ alertData.type ] // 清空步骤
					this.name = ''
					this.gender = ''
					this.contact = ''
					this.code = ''
					this.identity = ''

					// 判断简历完整度
					let res = await api.cvsV2.checkCv(this.cv.token)
					if (res.status === 1000) {
						this.cvCheck = res.data || {}
					}

          // 重制swiper
          if (alertData.image?.job_infos?.length || alertData.image?.comp_recruit_infos?.length) {
            this.swiperIndex = 0
            this.$refs.mySwiper?.initialSlide(0);
          }
				}
			},
			'edu.degree': {
				deep: true,
				immediate: true,
				handler: function (data) {
          if (data && this.edu.start_at) {
            const y = this.edu.start_at.split('-')[0];
            switch (data) {
              case "本科":
                this.defaultEduTimePicker = +y + 4 + '-06';
                break;
              case "MBA":
                this.defaultEduTimePicker = +y + 2 + '-06';
                break;
              default:
                this.defaultEduTimePicker = +y + 3 + '-06';
                break;
            }
          } else {
            this.defaultEduTimePicker = '';
          }
				}
			},
			'edu.start_at': {
				deep: true,
				immediate: true,
				handler: function (data) {
          if (this.edu.start_at) {
            const y = this.edu.start_at.split('-')[0];
            switch (data) {
              case "本科":
                this.defaultEduTimePicker = +y + 4 + '-06';
                break;
              case "MBA":
                this.defaultEduTimePicker = +y + 2 + '-06';
                break;
              default:
                this.defaultEduTimePicker = +y + 3 + '-06';
                break;
            }
          } else {
            this.defaultEduTimePicker = '';
          }
				}
			},
			// 监控cvs
			cvs: {
				deep: true,
				immediate: true,
				handler: function (cvs) {
					if (!cvs.length) {
						return false
					}
					for (let i = 0; i < cvs.length; i++) {
						if (!cvs[i].is_mentor && cvs[i].lang === 'cn') {
							this.cv = cvs[i]
							break
						}
					}
				}
			},
			data: {
				deep: true,
				immediate: true,
				handler: async function (data) {
					if (!data.show) {
						return false
					}
					if (data.type === 'baseInfo') {
						this.code = ''
					} else if (data.type === 'work') {
						setTimeout(() => {
							this.pickerOptions = {
								shortcuts: [ {
									text: '至今',
									onClick: (picker) => {
										picker.$emit('pick', '')
										setTimeout(() => {
											this.work = {
												...this.work,
												present: '至今',
												end_at: ''
											}
											this.getIsWorkNext()
										}, 50)
									}
								} ]
							}
						}, 100)
					} else if (data.type === 'onLine' && this.updatedType === 'updated') {
						let cv = []
						let cvs = this.cvs
						for (let i = 0; i < cvs.length; i++) {
							if (!cvs[i].is_mentor && cvs[i].lang === 'cn') {
								cv.push(cvs[i])
							}
						}
						if (cv.length === 1) {
							this.data.type = ''
							this.cv = {
								...cv[0],
								token: cv[0].token || cv[0].cv_token
							}
							this.selectCvNuxt()
						}
					}
				}
			},
		},
	  created () {
      this.host = window.location.origin.replace("www", "m")
			this._c_t = get_tUser().c_t || ''
			// 求职意向
			this.getIntention()
		},
		mounted () {},
		methods: {
			...mapActions('editor', [ 'getCvDetail', 'updateCvDetail', 'getExperience', 'createExperience', 'updateExperience' ]),
			...mapMutations('cvEditor', [ 'setCvToken' ]),
      recruitmentTime,
      //跳转详情页
      goToDetail (token) {
        if (!token) return;
        routerTo(`/comp_recruit_infos/${token}`, '_blank')
      },
      handleClickArrow(direction) {
        if (direction === 'right') {
          this.swiper.slideNext()
        } else {
          this.swiper.slidePrev()
        }
      },
      slideChange() {
        this.swiperIndex = this.swiper.realIndex;
      },
      //获取用户绑定信息
      async getUsersInfo(){
        let user_token = get_tUser().t || '';
        let res = await api.auth.get_users_bind_info(user_token)
        if(res.code === 1000){
          // 如果有绑定手机号
          if (res.data.phone) {
            this.contact = res.data.phone
            console.log(this.contact, res.data.phone, 'aaaaa')
          }
        }
      },
      closeDialog() {
				if (this.data.type === 'end' ) {
					this.close();
					this.$message.success(this.updatedType === 'updated' ? '简历已更新' : '简历已推荐')
        }
        if (this.data.type == 'drainage' || this.data.type == 'groups'|| this.data.type == 'cvsguanggao') {
          this.close();
        }
      },
			// 选择身份
			async selectIdentity (value) {
				this.identity = value
				// 提交数据
				let res = await api.cvsV2.setIdentifyInfo(this._c_t, { status: value === 1 ? 'student' : 'already_work' })
				if (res.code !== 1000) {
					this.selectIdentity(value)
					return false
				}
				if (this.alertData.showType === 'identity') {
					this.$emit('close')
					return false
				}
				// 下一步
				this.toStep()
			},
			// 发送验证码
			async sendCode () {
				let contact = String(this.contact).trim()
				let codeText = this.codeText
				let reg = /^1[3-9]\d{9}$/gim
				if (!reg.test(contact)) {
					this.$message.error('手机号格式不正确')
					return false
				}
				if (this.codeText !== '获取验证码') {
					return false
				}

				let res = await api.cvsV2.phoneValidateCode(this._c_t, { phone: contact })
				if (res.code === 1000) {
					let s = 60
					this.codeText = `${ s } 秒后重发`
					let run = setInterval(() => {
						s--
						this.codeText = `${ s } 秒后重发`
						if (s <= 0) {
							clearInterval(run)
							this.codeText = '获取验证码'
						}
					}, 1000)
				} else {
					this.$message.error('验证码发送失败')
				}
			},
			getShowPrev (type) {
				let step = this.step
				return step.indexOf(type) > 0
			},
			// 获取下一步
			getIsBaseInfoNuxt () {
				this.isBaseInfoNext = this.name
					&& this.gender
					&& (/^1[3-9]\d{9}$/gim).test(String(this.contact).trim())
					&& (
						this.isPhoneDisabled ||
						(!this.isPhoneDisabled && (/^\d{4,6}$/).test(this.code))
					)
			},
			baseInfoPrev () {
				this.toStepPrev()
			},
			async baseInfoNext () {
				if (!this.isBaseInfoNext) {
					let text = ''
					if (!this.name) text = '请填写姓名'
					if (!this.gender) text = '请选择性别'
					if (!String(this.contact).trim()) text = '请填写联系方式'
					if (!/^1[3-9]\d{9}$/.test(String(this.contact).trim())) text = '请正确填写联系方式'
					if (!this.isPhoneDisabled && !/^\d{4,6}$/.test(this.code)) text = '请填写验证码'
					this.$message.error(text)
					return false
				}
				if (!this.isPhoneDisabled) {
					let res = await api.cvsV2.validateCode(this._c_t, { phone: String(this.contact).trim(), code: this.code })
					if (res.code !== 1000) {
						this.$message.error('验证码不正确')
						return false
					}
				}
				let params = {
					name: this.name,
					gender: this.gender,
					contact: String(this.contact).trim()
				}
				let res = await api.cvsV2.setBasicInfo(this._c_t, params)
				if (res.code !== 1000) {
					this.$message.error()
				}
				this.isPhoneDisabled = true
				// 请求接口
				let next = this.toStepNext()
        if (!next && this.setReady) {
					this.createdOnlineCv()
				}
			},
			// 获取求职意向
			async getIntention () {
        // let userIntentionsQuery = await dealSignatrue()
        let userIntentions = await api.recruit.jobIntention({"platform": 'pc'})
        if (userIntentions.code && userIntentions.code === 1000) {
            await this.$store.dispatch('jobs/getIntention', userIntentions.data)
        }
        // 行业，筛选数据登
        await this.$store.dispatch('jobs/setIntention', conditions)
        this.intentionShow = true
			},
			// 求职意向上一步
			intentionPrev () {
				this.onlinePrev()
			},
			// 求职意向下一步
			intentionNext () {
				if (this.cnList.length > 1) {
					this.data.type = 'onLine'
					this.step.push('onLine')
        } else if (this.cnList.length === 1) {
					this.selectCvNuxt()
        }
			},
			// 选择简历
			selectCv (cv, index) {
				this.cv = cv
			},
			// 选择简历上一步
			onlinePrev () {
				this.toStepPrev()
			},
			// 选择简历下一步
			async selectCvNuxt () {
				if (!this.cv.token) {
					return false
				}
				// 判断简历完整度
				let res = await api.cvsV2.checkCv(this.cv.token)
				this.cvCheck = res.data || {}
				// 去除没用步数
				let step = this.step
				for (let i = 0; i < step.length; i++) {
					if (step[i] === 'onLine' && i < step.length - 1) {
						step = step.slice(0, i + 1)
						break
					}
				}
				// perfect 为信息全部完善
				if (this.data.showType === 'perfect') {
					step = []
				}
				this.step = step
				// 基本信息不完善
				if (!this.cvCheck.name_valid || !this.cvCheck.contact_valid || !this.cvCheck.gender_valid) {
					this.step.push('baseInfo')
				}
				// 教育不完善
				if (!this.cvCheck.edu_valid) {
					this.step.push('edu')
				}
				// 工作不完善
				if (!this.cvCheck.work_valid) {
					this.step.push('work')
				}

				// 基本信息完整，直接提交在线简历
				if (this.cvCheck.name_valid && this.cvCheck.contact_valid && this.cvCheck.gender_valid && this.cvCheck.edu_valid && this.cvCheck.work_valid) {
					this.createdOnlineCv()
					return false
				}
				// 获取基本信息
				if (!this.cvCheck.name_valid || !this.cvCheck.contact_valid || !this.cvCheck.gender_valid) {
          let user_token = get_tUser().t || '';
					res = await api.cvsV2.getBasicInfo(user_token, {})
					if (res.code === 1000) {
						this.name = res.data.name
						this.gender = res.data.gender
						this.contact = res.data.contact
						// this.isPhoneDisabled = !!res.data.contact
						this.isPhoneDisabled = !this.cvCheck.contact_valid ? false : !!res.data.contact
						this.getIsBaseInfoNuxt()
					} else {
						this.$message.error('基本信息获取失败')
					}
          this.getUsersInfo()
				}
				// 获取简历信息
				await this.getCvDetail(this.cv.token)
				let { submodule_info: { edus_ids, works_ids }, basic_info: { lang } } = this.cvDetail
				if (!this.cvCheck.edu_valid) {
					if (edus_ids.length) {
						let payload = { lang, ids: edus_ids[0] }
						await this.getExperience({ type: 'edus', payload })
					}
					this.edu = this.edus[0] || this.edu
					this.getIsEduNext()
				}
				if (!this.cvCheck.work_valid) {
					if (works_ids.length) {
						let payload = { lang, ids: works_ids[0] }
						await this.getExperience({ type: 'works', payload })
					}
					this.work = this.works[0] || this.works
					this.getIsWorkNext()
				}
				// 进入下一步或者提交简历
				let nuxt = ''
				if (this.data.showType === 'perfect') {
					this.data.type = this.step[0]
					nuxt = this.step[0]
				} else {
					nuxt = this.toStepNext()
				}
				if (!nuxt) {
					let res = await api.cvsV2.createdOnlineCv({ token: this.cv.token })
					if (res.code === 1000) {
						this.$message.success('在线简历创建成功')
						this.$emit('update')
					} else {
						this.$message.error(res.message)
					}
				}
				this.data.show = true
			},
			// 获取用户基本信息
			toStep () {
				let userIntentions = this.userIntentions
				let isIntention = userIntentions.profession_names === '未开启'
					|| userIntentions.intention_cities === '未开启'
					|| userIntentions.industry_names === '未开启'
					|| userIntentions.work_time === '未开启'
				if (isIntention) {
					this.data.type = 'intention'
					this.step.push('intention')
					return false
				}
				// 进入选简历弹窗
				else {
					this.data.type = 'onLine'
					this.step.push('onLine')
					return false
				}
			},
			// 单击下一步时的事件
			toStepNext () {
				let step = this.step
				for (let i = 0; i < step.length; i++) {
					if ((step[i] === this.data.type || this.data.type === '') && step.length > i + 1) {
						this.data.type = step[i + 1]
						return step[i + 1]
					}
				}
        this.setReady = true
				return false
			},
			// 点击上一步操作
			toStepPrev () {
				let step = this.step
				for (let i = 0; i < step.length; i++) {
					if (step[i] === this.data.type && i - 1 >= 0) {
						this.data.type = step[i - 1]
						return step[i - 1]
					}
				}
				return false
			},
			// 工作-上一步
			workPrev () {
				this.toStepPrev()
			},
			eduPrev () {
				this.toStepPrev()
			},
			// 工作下一步
			workNext () {
				let isTrue = this.work.start_at
					&& (this.work.end_at || this.work.present)
					&& new Date(this.work.start_at).getTime() > (this.work.present ? Date.now() : new Date(this.work.end_at).getTime())
				if (!this.isWorkNext) {
					let text = ''
					if (!this.work.company) text = '请填写公司'
					else if (!this.work.title) text = '请选择职位'
					else if (!this.work.start_at) text = '请选择开始时间'
					else if (!this.work.end_at && !this.work.present) text = '请选择结束时间'
					else if (isTrue) text = '开始时间不能晚于结束时间'
					this.$message.error(text)
					return false
				}
				this.toStepNext()
        this.saveWorkData()
			},
			eduNext () {
				if (!this.isEduNext) {
					let text = ''
					if (!this.edu.university) text = '请填写学校'
					else if (!this.edu.major) text = '请填写专业'
					else if (!this.edu.degree) text = '请选择学历'
					else if (!this.edu.start_at) text = '请选择开始时间'
					else if (!this.edu.end_at) text = '请选择结束时间'
					else if (this.edu.start_at && this.edu.end_at && new Date(this.edu.start_at).getTime() > new Date(this.edu.end_at).getTime()) text = '开始时间不能晚于结束时间'
					this.$message.error(text)
					return false
				}
				this.toStepNext()
        this.saveEduData()
			},
			// edu 表单改变时候的事件
			getIsEduNext (data) {
				// 判断开始结束时间
				if (this.edu.start_at && this.edu.end_at && new Date(this.edu.start_at).getTime() > new Date(this.edu.end_at).getTime()) {
					this.$message.error('开始时间不能晚于结束时间')
					this.isEduNext = false
					return false
				} else if (data && data.id && data.cn) {
					// 选择学历
          this.edu.degree = data.cn || null
          this.edu.degree_id = data.id || null
          if(!this.edu.degree){
            this.edu.edu_type = null
          } else if (!this.edu.edu_type){
            this.edu.edu_type = '全日制'
          }
        }
				this.isEduNext = this.edu.university
					&& this.edu.major
					&& this.edu.degree
					&& this.edu.start_at
					&& this.edu.end_at
			},
			// work 改变时候的事件
			getIsWorkNext () {
				// 判断开始结束时间
				let isTrue = this.work.start_at
					&& (this.work.end_at || this.work.present)
					&& new Date(this.work.start_at).getTime() > (this.work.present ? Date.now() : new Date(this.work.end_at).getTime())
				if (isTrue) {
					this.$message.error('开始时间不能晚于结束时间')
					this.isWorkNext = false
					return false
				}
				this.isWorkNext = this.work.company
					&& this.work.title
					&& this.work.start_at
					&& (this.work.end_at || this.work.present)
			},
			// 更新教育 或者 工作的信息
			async _saveExperience (formData, type) {
				try {
          if (formData.id && formData.kind !== 'sample') {
            let res = await this.updateExperience({ type, payload: {...formData, lang: 'cn'} })
            if (res.code === 1000) this.updateCvData(type)
          } else {
            let res = await this.createExperience({ type, payload: {...formData, lang: 'cn'} })
            if (res.code === 1000) this.updateCvData(type, [ res.data[type].id ])
          }
        } catch (error) {
          console.log(error)
        }
			},
      cvslink(link, type){
        if (!this.alertData.image?.job_infos?.length && !this.alertData.image?.comp_recruit_infos?.length || type === 'button') {
          window.open(link, '_blank');
          this.close();
        }
      },
      clickBannerImage(bannerData) {
        const { job_infos = [], comp_recruit_infos = [], link = '', deliver_channel } = bannerData;
        if(deliver_channel){
          let jobToken = job_infos.length ? job_infos[0].token : '';
          let url = location.href
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'aliJobDelivery',
            deliveryJobOptions: {
              jobToken: jobToken,
              title: bannerData.title
            },
            isDarkTheme: url.includes('/cvs'),
          });
          return
        }
        if (job_infos.length || comp_recruit_infos.length) return;
        if (link.startsWith('https://buymember#')) {
          const [_, dialogMemberConfigStr] = link.split('#');
          this.close();
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip',
            dialogMemberConfigStr,
            downloadContinue: () => {},
            displayContinueBtn: false,
          });
        } else if (link) {
          window.open(link, '_blank');
        }
      },
			// 保存edu数据
			saveEduData () {
				this._saveExperience(this.edu, 'edus')
			},
			// 更新work数据
			saveWorkData () {
				this._saveExperience(this.work, 'works')
			},
			// 更新简历数据
			async updateCvData (type, ids) {
				try {
          let { submodule_info: { sections_position }, basic_info: { token } } = this.cvDetail
          const index = sections_position.findIndex(item => item.type === type)
          let position = JSON.parse(JSON.stringify(sections_position))
          if (index === -1) {
            position = [ ...sections_position, { id: null, type, info_ids: [] } ]
          }
          let payload = {
            operation_type: 'update_submodule_info',
            submodule_info: {
              sections_position: position
            }
          }
          if (ids) payload.submodule_info[`${ type }_ids`] = ids
          await this.updateCvDetail(payload)
          if (this.setReady) {
            this.createdOnlineCv()
          }
        } catch (error) {
          console.log(error)
        }
			},
			// 创建在线简历
			async createdOnlineCv () {
				let res = await api.cvsV2.createdOnlineCv({ token: this.cv.token })
				if (res.code === 1000) {
					this.data.type = 'end'
					this.step.push('end')
				} else {
					this.$message.error('提交失败，请重试')
				}
			},
			// 关闭
			close (type) {
				this.$emit('close')
        if (type === 'downloadApp') {
	        this.$emit('changeDownloadAppState')
        }
			},
		},
	}
</script>
<style lang="scss" scoped>
  .cvs-alert-main {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    & > * {
      box-sizing: border-box;
    }
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
    }
    .box {
      position: fixed;
      background: #fff;
      width: 540px;
      border-radius: 4px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      padding: 32px;
      box-sizing: border-box;

      .btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        button {
          width: 84px;
          height: 36px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          font-size: 14px;
          color: #606060;
          display: block;
          background: #fff;
          &.prev-btn:hover {
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &:last-child {
            margin-left: 16px;
          }
          &.disabled {
            border-color: #CFCFCF;
            background: #CFCFCF;
            color: #fff;
          }
          &.active {
            border-color: #FF4F4C;
            background: #FF4F4C;
            color: #fff;
            &:hover {
              background: #FF716E;
              border-color: #FF716E;
            }
          }
        }
      }
      .close {
        position: absolute;
        top: 38px;
        right: 38px;
        cursor: pointer;
        font-size: 16px;
        color: #9C9C9C;
        font-weight: 600;;
      }
      &.identity {
        height: 488px;
        .identity-title {
          font-size: 26px;
          color: #404040;
          text-align: center;
          margin-top: 78px;
        }
        .identity-option {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 77px;
          .identity-item {
            cursor: pointer;
            &:last-child {
              margin-left: 92px;
            }
            img {
              display: block;
              width: 88px;
              height: 88px;
            }
            p {
              font-size: 16px;
              color: #404040;
              text-align: center;
              margin-top: 16px;
            }
          }
        }
      }
      &.on-line {
        height: 488px;
        .on-title {
          margin-top: 10px;
          font-size: 16px;
          color: #404040;
        }
        .on-msg {
          font-size: 14px;
          color: #9C9C9C;
          margin-top: 16px;
        }
        .on-content {
          background: #F9F9F9;
          height: 258px;
          border-radius: 4px;
          margin-top: 32px;
          margin-bottom: 40px;
          padding: 4px 32px;
          overflow-y: auto;
          .on-menu {
            height: 48px;
            display: flex;
            align-items: center;
            cursor: pointer;
            & > div {
              flex: none;
            }
            &.active {
              .on-menu-select {
                border-color: #FF4F4C;
                background: #FF4F4C;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                .iconfont {
                  display: block;
                }
              }
            }
            .on-menu-select {
              width: 18px;
              height: 18px;
              border-radius: 10px;
              border: 1px solid #CFCFCF;
              .iconfont {
                display: none;
                margin-left: 1px;
              }
            }
            .on-menu-text {
              height: 24px;
              line-height: 24px;
              flex: 1;
              margin: 0 18px;
            }
            .on-menu-tag {
              display: flex;
              align-items: center;
              & > div {
                height: 24px;
                padding: 0 14px;
                text-align: center;
                line-height: 24px;
                margin-right: 10px;
                font-size: 12px;
                flex: none;
                &:last-child {
                  margin-right: 0;
                }
                &.blue {
                  background: rgba(65, 131, 255, 0.08);
                  color: #4183FF;
                }
                &.red {
                  background: rgba(255, 79, 76, 0.08);
                  color: #FF4F4C;
                }
              }
            }
          }
        }
      }
      &.base-info {
        height: 488px;
        .base-title {
          font-size: 16px;
          color: #404040;
          margin-top: 10px;
          font-weight: 700;
        }
        .base-msg {
          font-size: 14px;
          color: #404040;
          margin-top: 38px;
        }
        .base-name {
          font-size: 12px;
          color: #9C9C9C;
          height: 38px;
          line-height: 40px;
        }
        .base-option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .base-item {
            width: 220px;
          }
        }
        .base-form {
          margin-bottom: 64px;
          margin-top: 8px;
        }
      }
      &.end {
        height: 488px;
        .end-img {
          display: block;
          width: 148px;
          margin: 28px auto 0;
        }
        .end-title {
          font-size: 20px;
          color: #404040;
          text-align: center;
          margin-top: 22px;
        }
        .end-msg {
          font-size: 16px;
          color: #9C9C9C;
          margin-top: 12px;
          text-align: center;
        }
        .end-btn {
          display: block;
          width: 246px;
          height: 44px;
          background: #FF4F4C;
          color: #fff;
          font-size: 16px;
          margin: 56px auto 0;
          border-radius: 2px;
          &:hover {
            border-color: #FF716E;
            background: #FF716E;
          }
        }
      }
    }
    .download-app{
      padding: 32px 0;
      width: 340px;
      height: 348px;
      text-align: center;
      .title{
        font-weight: 500;
        font-size: 24px;
        color: #303030;
        margin-bottom: 14px;
      }
      .score{
        font-size: 14px;
        line-height: 22px;
        color: #404040;
        &>span{
          color: #FF6644;
        }
      }
      .bottom{
        font-size: 14px;
        color: #9c9c9c;
      }
      &>img{
        width: 158px;
        height: 158px;
        object-fit: contain;
        margin: auto;
        margin-top: 24px;
        margin-bottom: 28px;
      }
    }

    .groups {
      display: flex;
      width: 600px;
      height: 368px;
      padding: 0;
      background: #FFFFFF;
      border-radius: 10px;
      box-sizing: border-box;

      .groups-left {
        position: relative;
        width: 284px;

        .groups-left-bg {
          position: absolute;
          top: -61px;
          left: 0;
          z-index: -1;
          width: 284px;
        }

        .groups-left-title {
          position: absolute;
          top: 76px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 20px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 22px;
        }

        .groups-left-item {
          position: absolute;

          >h6 {
            font-size: 14px;
            font-weight: 500;
            color: #FF6635;
            line-height: 14px;
            margin-bottom: 9px;
          }

          >p {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 500;
            color: #404040;
            line-height: 16px;

            >span {
              display: inline-block;
              max-width: 128px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          &:nth-of-type(1) {
            top: 133px;
            left: 48px;
          }
          &:nth-of-type(2) {
            top: 207px;
            left: 48px;
          }
          &:nth-of-type(3) {
            top: 280px;
            left: 48px;
          }

        }

      }

      .groups-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .groups-right-logo {
          // width: 120px;
          height: 40px;
          margin: 28px 0 16px;
        }

        .groups-right-title {
          font-size: 20px;
          font-weight: 600;
          color: #404040;
          line-height: 22px;
          margin-bottom: 22px;
        }

        .groups-right-qrcode {
          width: 170px;
          margin-bottom: 20px;
          ::v-deep img {
            width: 100%;
          }
        }
        .groups-right-desc {
          font-size: 14px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 20px;
        }

      }
    }
  }
  .groups-cvs {
        padding: 0 !important;
        width: 600px !important;
        height: 350px ;
        text-align: center;
        border-radius: 6px !important;
        background: transparent !important;
        overflow: hidden;
        &>img{
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }

  .jobs-dialog-container {
    position: relative;
    width: 600px;
    height: 350px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 16px;
    padding-top: 115px;
    box-sizing: border-box;
    .jobs-swiper {
      height: 153px;
      ::v-deep(.swiper-wrapper) {
        display: flex;
        flex-wrap: nowrap;
      }

      .swiper-slide {
        width: 440px;
        height: 153px;
        background-color: #fff;
        flex-shrink: 0;
        border-radius: 12px;
        opacity: 1;
        transition: opacity .2s;
        .jobs-item-card-main {
          height: 153px;
        }
        .job-card-content {
          display: flex;
          padding: 20px 24px;
          height: 153px;
          box-sizing: border-box;
          cursor: pointer;
          &:hover{
            box-shadow: 0px 2px 28px 0px rgba(10,44,156, .1);
            .infos_comp{
              color: #FF6644 !important;
            }
          }
          .content_img {
            width: 60px;
            height: 60px;
            margin-right: 12px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 4px;
              border: 1px solid #f9f9f9;
            }
          }
          .category-info{
            flex: 1;
          }
          .content_infos {
            text-align: left;
            border-bottom: 1px dashed #ECECEC;
            padding-bottom: 12px;
            margin-bottom: 10px;
            margin-top: 10px;
            .infos_comp{
              max-width: 260px;
              height: 20px;
              font-size:18px;
              font-weight:500;
              color:rgba(64,64,64,1);
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .infos_cate {
              margin: 8px 0;
              height:14px;
              font-size:14px;
              color:#9C9C9C;
            }
            .infos_time {
              font-size:12px;
              color:#404040;
            }
          }
          .time {
            display: flex;
            background: #f9f9f9;
            height: 28px;
            border-radius: 14px;
            line-height: 28px;
            width: max-content;
            padding-right: 8px;
            i {
              margin-right: 8px;
              margin-left: 10px;
            }
            p {
              font-size: 14px;
              color: #404040;
            }
          }
        }
      }

      .swiper-slide-next,
      .swiper-slide-prev {
        opacity: 0.4;
      }
    }

    .left-arrow,
    .right-arrow {
      position: absolute;
      top: 180px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    .left-arrow {
      left: 24px;
    }
    .right-arrow {
      right: 24px;
    }

    .bottom-btn {
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 48px;
      height: 40px;
      background-color: #FF6644;
      color: #fff;
      font-size: 14px;
      border-radius: 100px;
      cursor: pointer;
    }
  }
</style>
<style lang="scss">
  .cvs-alert-main {
    .box {
      .el-form-item {
        margin: 0;
        padding: 0;
      }
      .el-input__inner {
        border-color: #DEDFE1 !important;
        &:focus {
          border-color: #DEDFE1 !important;
        }
      }
      .phone {
        .el-input-group__prepend {
          padding: 0 !important;
          width: 58px !important;
          text-align: center;
          background: #fff !important;
          position: relative;
          color: #606266 !important;
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 22px;
            background: #ECECEC;
            position: absolute;
            top: 50%;
            margin-top: -11px;
            right: 0;
          }
        }
        .el-input-group__append {
          width: 32px !important;
          background: #fff !important;
          padding: 0 !important;
          text-align: center !important;
          color: #4C84FF !important;
          position: absolute;
          height: 100%;
          line-height: 40px;
          border: none;
          top: 0;
          right: 24px;
          background: transparent !important;
          text-align: right;
          span {
            cursor: pointer;
          }
        }

        .el-input__inner {
          border-left: none !important;
          border-radius: 0 4px 4px 0 !important;
        }
      }
      .code {
        .el-input-group__append {
          width: 102px !important;
          background: #fff !important;
          padding: 0 !important;
          text-align: center !important;
          color: #4C84FF !important;
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 22px;
            background: #ECECEC;
            position: absolute;
            top: 50%;
            margin-top: -11px;
            left: 0;
          }
          span {
            cursor: pointer;
          }
        }
        .el-input__inner {
          border-right: none !important;
        }
      }
      .el-input.is-disabled .el-input__inner {
        background: transparent !important;
        color: #606266 !important;
      }
    }
  }
</style>

<style lang="scss">
  .cvs-alert-main {
    .edit-item-now {
      // width: calc(100% - 32px);
      border-radius: 4px;
      height: calc(100% - 4px);
      position: absolute;
      left: 48px;
      right: 1px;
      top: 2px;
      background: #fff;
      z-index: 9;
      // opacity: .5;
      pointer-events: none;
      line-height: 38px;
      padding-left: 2px;
      color: #606266;
    }
    .el-select {
      width: 100%;
    }
  }
  .el-picker-panel__shortcut,
  .el-month-table td .cell {
    color: #404040;
  }
  .el-month-table td .cell:hover {
    color: #409EFF;
  }
  .el-date-picker.has-sidebar {
    width: 322px;
  }
  .el-picker-panel.has-sidebar {
    height: 313px;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    bottom: 2px;
    right: 0;
    left: -1px;
    top: auto;
    width: calc(100% + 2px);
    display: flex;
    justify-content: center;
    padding: 10px 30px;
    transform: translateY(3px);
    // background: red;
    border: 1px solid #EBEEF5;
    z-index: 9;
    margin-top: -2px;
    border-radius: 0 0 4px 4px;
    button {
      width: 50px;
      // border: 1px solid #EBEEF5;
      font-size: 12px;
      border-radius: 2px;
    }
  }
  .el-picker-panel [slot=sidebar] + .el-picker-panel__body, .el-picker-panel__sidebar + .el-picker-panel__body {
    margin: 0;
  }
</style>
